module.exports = __webpack_public_path__ + "img/splash.26bd3506.jpg";